import { Component, OnInit, Input } from '@angular/core';
import { Router } from '@angular/router';

@Component({
    selector: 'app-header',
    templateUrl: './header.component.html',
    styleUrls: ['./header.component.scss']
})
export class HeaderComponent implements OnInit {
    @Input() showProgressBar: boolean = true;
    @Input() title: string = 'my account';

    public constructor(private router: Router) {}

    ngOnInit(): void {}

    public navigateToUrl(url: string): void {
        this.router.navigateByUrl('/my-account/' + url);
    }

    public checkIfLinkActive(url: string): boolean {
        if (this.router.url.indexOf(url) > -1) {
            return true;
        }
        return false;
    }
}
